import { styled } from '@quillbot/design-system';
import { DEVICE_VIEWPORTS } from 'config/constants';

const ShowInMobile = styled('div')`
  display: none;
  @media ${DEVICE_VIEWPORTS.xs} {
    display: block;
  }
`;
export default ShowInMobile;
